/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { agentArtifactsControllerGetDownloadUrl } from "./agentArtifactsControllerGetDownloadUrl";
import { agentArtifactsControllerGetNutrientConfig } from "./agentArtifactsControllerGetNutrientConfig";

export function agentArtifactsService() {
  return { agentArtifactsControllerGetDownloadUrl, agentArtifactsControllerGetNutrientConfig }
}